import React, { FC } from 'react'
import { IonHeader } from '@ionic/react'
import { observer } from 'mobx-react'
import './index.scss'

interface IProps {
  className?: string;
  title?: string;
  extra?: any;
  animation?: boolean;
  onBack?: () => void;
  noShadow?: boolean;
  children?: any;
}

const UseHeader: FC<IProps> = ({ className, title, extra, noShadow, animation, onBack, children }: IProps) => {
  return (
    <IonHeader
      className='navigator'
    >
      <div className={`mkt-header ${className || ''} ${animation ? 'animation' : ''} ${noShadow ? 'noShadow' : ''}`}>
        <div className='left'>
          {onBack && <div data-cypid='mmgHeaderBack' className='left-back' onClick={onBack}><i className='iconfont icon-BACK-12x'></i></div>}
          {
            title &&
              <div className='title'>{title || ''}</div>
          }
        </div>
        <div className='right'>
          {extra}
        </div>
      </div>
      {children}
    </IonHeader>
  )
}

export default observer(UseHeader)
